// extracted by mini-css-extract-plugin
export default {"paymentSection":"t1-z"};